"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M4 22H2V2h2zM22 7H6v3h16zm-6 7H6v3h10z"
}), 'AlignHorizontalLeftSharp');